/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const StartNativeSignupBody = zod.object({
  email: zod.email(),
  firstName: zod.string().min(1),
  homeRegion: zod
    .enum(['au', 'us'])
    .optional()
    .describe("One of OnEarly's regions: `au` (Australia) or `us` (United States)."),
  lastName: zod.string().min(1),
  phoneNumber: zod.string().min(1),
});

export type StartNativeSignupBody = zod.input<typeof StartNativeSignupBody>;
export type StartNativeSignupBodyOutput = zod.output<typeof StartNativeSignupBody>;
